var fonts = {
    body: "'Work Sans', sans-serif",
    heading: "'Work Sans', sans-serif",
};

export { fonts as default };
//# sourceMappingURL=fonts.js.map
